import { render, staticRenderFns } from "./EMRepairOrderDetailList.vue?vue&type=template&id=b5f48e30&scoped=true"
import script from "./EMRepairOrderDetailList.vue?vue&type=script&lang=js"
export * from "./EMRepairOrderDetailList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f48e30",
  null
  
)

export default component.exports